"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const react_1 = __importDefault(require("react"));
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const styles_1 = require("./styles");
const Text = (props) => {
    const { children, copy, inline, 'aria-level': ariaLevel } = props, rest = __rest(props, ["children", "copy", "inline", 'aria-level']);
    const content = (react_1.default.createElement(react_1.default.Fragment, null,
        copy ? (0, html_react_parser_1.default)(copy) : '',
        children));
    let ariaProps = {};
    if (ariaLevel) {
        ariaProps = {
            role: 'heading',
            'aria-level': ariaLevel
        };
    }
    return inline ? (react_1.default.createElement(styles_1.StyledSpan, Object.assign({}, rest, ariaProps), content)) : (react_1.default.createElement(styles_1.StyledDiv, Object.assign({}, rest, ariaProps), content));
};
exports.Text = Text;
